export default {
  清空条件: '清空条件',
  任务中心: '任务中心',
  请选择状态: '请选择状态',
  请选择类型: '请选择类型',
  下载异常详情: '下载异常详情',
  下载校准详情: '下载校准详情',
  重试: '重试',
  耗时: '耗时',
  年: '年',
  月: '月',
  日: '日',
  时: '时',
  分: '分',
  秒: '秒'
};
